<template>
  <div class="addNewClass">
    <div class="content">
      <div class="operation">
        <el-button type="primary" :round="false" size="small" disabled>
          <span>添加商品标签组</span>
        </el-button>
      </div>
      <el-row :gutter="40">
        <el-col :span="2">
          <div class="grid-content bg-purple name">
            <span>排序</span>
          </div>
        </el-col>
        <el-col :span="19">
          <div class="grid-content bg-purple">
            <el-input
              v-model="sort"
              placeholder="请输入内容"
              size="small"
            ></el-input>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="2">
          <div class="grid-content bg-purple name">
            <span>标签组名称</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="19">
          <div class="grid-content bg-purple">
            <el-input
              v-model="name"
              placeholder="请输入内容"
              size="small"
            ></el-input>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="2">
          <div class="grid-content bg-purple name">
            <span>标签</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content bg-purple">
            <el-input
              v-model="labelValue"
              placeholder="请输入内容"
              size="small"
            ></el-input>
          </div>
        </el-col>
        <el-col :span="16">
          <div class="grid-content bg-purple labelsort">
            <div class="label" v-for="(item, index) in labelGroup" :key="index">
              <span>{{ item }}</span>
              <div class="close" @click="deletelabel(index)">
                <span>×</span>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="2">
          <div class="grid-content bg-purple name"></div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content bg-purple">
            <el-button :round="false" size="small" @click="addValue">
              <span>添加标签</span>
            </el-button>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="2">
          <div class="grid-content bg-purple name">
            <span>是否显示</span>
          </div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">
            <template>
              <el-radio v-model="showRadio" label="1">是</el-radio>
              <el-radio v-model="showRadio" label="0">否</el-radio>
            </template>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="margin-bottom:40px">
        <el-col :span="2">
          <div class="grid-content bg-purple name">
            <el-button
              type="primary"
              size="small"
              style="margin-left:15px;"
              @click="submit"
            >
              <span>提交</span>
            </el-button>
          </div>
        </el-col>
        <el-col :span="18">
          <div class="grid-content bg-purple">
            <el-button size="small" style="margin-left:15px;" @click="returnUp">
              <span>返回列表</span>
            </el-button>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { addlabel } from "@/api/mall";
export default {
  computed: {
    ...mapGetters(["token", "app_id", "merch_id"])
  },
  data() {
    return {
      sort: "",
      name: "",
      labelValue: "",
      labelGroup: [],
      idx: 1,
      nowIDx: 0,
      value: "",
      input: "",
      showRadio: "1"
    };
  },
  methods: {
    returnUp() {
      this.$emit("closelabel", false);
    },
    addValue() {
      if (this.labelValue == "") {
        this.$message("请输入内容");
      } else {
        this.labelGroup.push(this.labelValue);
        this.labelValue = "";
        console.log(this.labelGroup);
      }
    },
    deletelabel(index) {
      this.labelGroup.splice(index, 1);
    },
    submit() {
      let value = this.labelGroup.join();
      console.log(this.showRadio);
      let data = {
        token: this.token,
        app_id: this.app_id,
        merch_id: this.merch_id,
        name: this.name,
        sort: this.sort,
        value: value,
        is_show: this.showRadio
      };
      addlabel(data).then(res => {
        if (res.code == 0) {
          this.$message({
            message: res.msg,
            type: "warning"
          });
        } else {
          console.log(res);
          this.$message({
            message: res.msg,
            type: "success"
          });
          this.name = "";
          this.sort = "";
          this.labelGroup = [];
          this.$emit("closelabel", false);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.addNewClass {
  height: 100%;
  position: relative;
  .content {
    position: absolute;
    top: 0px;
    bottom: 26px;
    left: 22px;
    right: 70px;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    padding: 30px;
    .operation {
      height: 50px;
    }
    .el-row {
      margin-top: 15px;
    }
    .grid-content {
      line-height: 36px;
      min-height: 36px;
      .label {
        // width: 70px;
        line-height: 20px;
        // height: 20px;
        padding: 5px 15px;
        border-radius: 20px;
        background: rgba(64, 158, 255, 0.1);
        text-align: center;
        margin-right: 10px;
        position: relative;
        .close {
          width: 15px;
          height: 15px;
          border-radius: 50%;
          background: #ff00004f;
          line-height: 15px;
          position: absolute;
          right: 0;
          top: -5px;
        }
      }
    }
    .labelsort {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .name {
      text-align: right;
    }
    .rgt {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
  }
}
</style>
